/* Todo, discuss, I think it would be beneficial if we had the theme available here */
export default {
  text: 'Your Button',
  subtext: '',
  variant: 'solid',
  size: 'm',
  fullWidth: false,
  icon: '',
  iconAlignment: 'end',
  color: undefined,
  border: undefined,
  background: undefined,
  attentionSeeker: 'none',
  // color: 'var(--color-white)',
  // border: 'var(-color-primary)',
  // background: 'var(--color-primary)'
};
